// import { ReactNode } from 'react';
// import Header from '../elements/Header/Header';
// import Footer from '../elements/footer/Footer';
// import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
// import SupportWidget from '../components/AdminSupportButton';
// import { getSettings } from '@/core/lib/api/account/settings';


// export default async function MainLayout({
//     children,
// }: Readonly<{
//     children: ReactNode;
// }>) {
//     const settingsRes = await getSettings().catch(() => null);
//     const isSupportActive = settingsRes?.data?.support_widget_active !== 'deactive';
//     return (
//         <>
//             <OrganizationSchema /> {/* ✅ Invisible - only for search engines to improve seo - because of the <script type="application/ld+json"> tag in the file */}
//             <Header />
//             <main className="flex flex-col bg-r min-h-[calc(100vh-72px)]">
//                 <div className="min-h-full">{children}</div>
//                 <Footer />
//             </main>
//             <SupportWidget active={isSupportActive} />
//         </>
//     );
// }


import { ReactNode } from 'react';
import Header from '../elements/Header/Header';
import Footer from '../elements/footer/Footer';
import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
import SupportWidget from '../components/AdminSupportButton';
import { getMetadata as getPublicSettings } from '@/core/lib/api/main/setting';

export const dynamic = 'force-dynamic';

export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    const settingsRes = await getPublicSettings().catch(() => null);
    const isSupportActive = settingsRes?.support_widget_active !== 'deactive';
    return (
        <>
            <OrganizationSchema /> {/* ✅ Invisible - only for search engines to improve seo - because of the <script type="application/ld+json"> tag in the file */}
            <Header />
            <main className="flex flex-col bg-r min-h-[calc(100vh-72px)]">
                <div className="min-h-full">{children}</div>
                <Footer />
            </main>
            <SupportWidget active={isSupportActive} />
        </>
    );
}